import { client } from "@/assets/js/pocketbase";
import user from "@/store/user.js";

export function initUserFromSession() {
    const model = client.authStore?.model;
    const isValid = !!(client.authStore?.isValid && model);

    if (!isValid) {
        const previousId = user.val("id");
        if (previousId) {
            user.commit("id", null);
            user.commit("email", "");
            user.commit("name", "");
            user.commit("tenant", null);
            user.commit("role", "staff");
            user.commit("master", false);
            user.commit("activeShiftSessionID", null);
        }
        return;
    }

    const previousId = user.val("id");

    if (model.collectionName === "users") {
        const role = model.role || "staff";

        if (previousId && previousId !== model.id) {
            user.commit("activeShiftSessionID", null);
        }
        user.commit("id", model.id);
        user.commit("email", model.email || "");
        user.commit("name", model.name || "");
        user.commit("tenant", model.tenant || null);
        user.commit("role", role);
        user.commit("master", role === "admin");
        return;
    }

    if (previousId && previousId !== model.id) {
        user.commit("activeShiftSessionID", null);
    }
    user.commit("id", model.id);
    user.commit("email", model.email || "");
    user.commit("name", model.name || "");
    user.commit("tenant", null);
    user.commit("role", "admin");
    user.commit("master", true);
}

